import React from 'react';
import { motion } from 'framer-motion';
import { Flag, Bot, BarChart3, Sparkles } from 'lucide-react';
import SpotlightCard from './SpotlightCard';
import { Translations } from '../types';

interface MilestonesProps {
  t: Translations;
}

const icons = [Flag, Bot, BarChart3, Sparkles];

export const Milestones: React.FC<MilestonesProps> = ({ t }) => {
  return (
    <section className="milestones" aria-labelledby="milestones-heading" id="roadmap">
      <div className="container">
        <motion.div
          className="milestones-header"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <p className="milestones-eyebrow">{t.milestones.subtitle}</p>
          <h2 id="milestones-heading" className="milestones-title">
            {t.milestones.title}
          </h2>
        </motion.div>

        <div className="milestones-grid" role="list" aria-label="产品路线图">
          {t.milestones.items.map((item, index) => {
            const Icon = icons[index % icons.length];
            return (
              <motion.article
                key={item.date + item.title}
                role="listitem"
                className="milestone-card-wrapper"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.12 }}
                viewport={{ once: true }}
              >
                <SpotlightCard className="milestone-card" spotlightColor="rgba(0, 255, 157, 0.12)">
                  <div className="milestone-meta">
                    <span className="milestone-date">{item.date}</span>
                    {item.status && (
                      <span className="milestone-status" aria-label={item.status}>
                        {item.status}
                      </span>
                    )}
                  </div>
                  <div className="milestone-icon" aria-hidden="true">
                    <Icon size={22} />
                  </div>
                  <h3 className="milestone-title">{item.title}</h3>
                  <p className="milestone-description">{item.description}</p>
                </SpotlightCard>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
